<script>
// Bot yapilandirmasi sekmesi.
//
// Chatwoot'un "Agent Bot" bolumu BURADAN KALDIRILDI. O bolum konusmayi
// asistandan alip bir webhook'a devrediyordu ve asistanla ayni kutuda
// birlikte calismiyordu (ikisi de ai_assignee uzerinde yarisiyor).
// Yerine gecen agent secimi tam tersini yapiyor: asistan konusmayi
// yonetmeye devam ediyor, agent'i bir arac olarak cagiriyor.
//
// Agent Bot'un API'si ve arka ucu Chatwoot'ta duruyor; yalnizca bu
// ekrandan kaldirildi.
import OmnupAsistanBaglama from './OmnupAsistanBaglama.vue';
import OmnupAgentSecimi from './OmnupAgentSecimi.vue';

export default {
  components: {
    OmnupAsistanBaglama,
    OmnupAgentSecimi,
  },
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-6 mx-6 max-w-4xl">
    <!-- 1) Asistan: kutuya baglayinca o kutudaki TUM yeni konusmalari
         otomatik yanitliyor. -->
    <OmnupAsistanBaglama :inbox="inbox" />

    <!-- 2) Agentlar: asistanin bu kutuda cagirabilecegi webhook'lar.
         Konusmayi devralmiyorlar, asistanin elindeki arac oluyorlar. -->
    <OmnupAgentSecimi :inbox="inbox" />
  </div>
</template>
